module.exports = __webpack_public_path__ + "static/media/drop-7-copy@1x.e84904a4.png";